if (!window.buyboxEnabled) {
	/**
	 * Toggle Selling Plan Options & Content
	 */
	toggleSellingPlanOptions();
	
	/**
	 * Default Subscription Option for Quantity Tabs
	 */
	handleVariantTabs();
	
	/**
	 * Handle Quantity Tabs
	 */
	handleQuantityTabs
	
	/**
	 * Direct to Checkout w/ Promo
	 */
	directCheckout(window.promotions);

	window.buyboxEnabled = true;
}


// Update subscription options when quantity tab is clicked
function handleVariantTabs() {
	const productForms = document.querySelectorAll(".product-form-tabs");
	productForms.forEach((productForm) => {
		const variantTabs = productForm.querySelector(".variant-options");
		if (!variantTabs) return;
		variantTabs.addEventListener("click", (e) => {
			if (e.target.dataset.subscription) {
				const subscriptionOptions = productForm.querySelectorAll(".selling-plan-options .selling-plan-select option");
				subscriptionOptions.forEach((option) => {
					if (option.innerHTML.includes(e.target.dataset.subscription)) {
						option.selected = true;
					}
				});
			}
		});
	});
}

// Update subscription options when quantity tab is clickeda
function handleQuantityTabs() {
	const productForms = document.querySelectorAll(".product-form-tabs");
	productForms.forEach((productForm) => {
		const quantityTabs = productForm.querySelector(".quantity-tabs");
		if (!quantityTabs) return;
		quantityTabs.addEventListener("click", (e) => {
			if (e.target.dataset.subscription) {
				// Update Subscription Options
				const subscriptionOptions = productForm.querySelectorAll(".selling-plan-options .selling-plan-select option");
				if (subscriptionOptions) {
					subscriptionOptions.forEach((option) => {
						if (option.innerHTML.includes(e.target.dataset.subscription)) {
							option.selected = true;
						}
					});
				}
				// Swap Featured Image
				const featuredImageSwap = e.target.closest("label").querySelector(".featured-image-swap");
				const productMediaList = document.querySelector(".product__media-list");
				if (featuredImageSwap && productMediaList) {
					productMediaList.querySelector("li .product__media").innerHTML = featuredImageSwap.innerHTML;
				}
			}
		});
	});
}

// Toggle #selling_plan_options disabled attribute when #sp-active is selected
function toggleSellingPlanOptions() {
	const buyBoxes = document.querySelectorAll('.buy-box--main');
	buyBoxes.forEach((buyBox) => {
		const product_forms = buyBox.querySelectorAll(".product-form-tabs");
		const updateAll = buyBox.classList.contains('buy-box--tabs');

		// Handle Subscription Options per product form
		product_forms.forEach((form) => {
			form.addEventListener("click", (e) => {
				if (e.target.classList.contains("selling-plan-option")) {
					if (e.target.value == "true") {
						if (updateAll) {
							product_forms.forEach((f) => {
								let labels = f.querySelectorAll(".subscription-options label");
								labels.forEach((label) => {
									if (label.classList.contains('option-subscribe')) {
										label.classList.add("selected");
										label.querySelector("input").checked = true;
									} else {
										label.classList.remove("selected");
										label.querySelector("input").checked = false;
									}
								});
								let selling_plan_options = f.querySelector(".selling-plan-select");
								selling_plan_options.disabled = false;
								f.classList.add("subscription-checked");
								f.classList.remove("one_time-checked");
							});
						} else {
							let selling_plan_options = form.querySelector(".selling-plan-select");
							selling_plan_options.disabled = false;
							form.classList.add("subscription-checked");
							form.classList.remove("one_time-checked");
						}
					} else {
						if (updateAll) {
							product_forms.forEach((f) => {
								let labels = f.querySelectorAll(".subscription-options label");
								labels.forEach((label) => {
									if (label.classList.contains('option-one-time')) {
										label.classList.add("selected");
										label.querySelector("input").checked = true;
									} else {
										label.classList.remove("selected");
										label.querySelector("input").checked = false;
									}
								});
								let selling_plan_options = f.querySelector(".selling-plan-select");
								selling_plan_options.disabled = true;
								f.classList.remove("subscription-checked");
								f.classList.add("one_time-checked");
							});
						} else {
							let selling_plan_options = form.querySelector(".selling-plan-select");
							selling_plan_options.disabled = true;
							form.classList.remove("subscription-checked");
							form.classList.add("one_time-checked");
						}
					}
					// Update active label
					if (!updateAll) {
						let labels = form.querySelectorAll(".subscription-options label");
						labels.forEach((label) => {
							if (label.htmlFor == e.target.id) {
								label.classList.add("selected");
							} else {
								label.classList.remove("selected");
							}
						});
					}
				}
			})
		});
	});
}

function directCheckout(promos) {
	console.log('directCheckout')
	const tabsForms = document.querySelectorAll("product-form.product-form-tabs");
	const buttonForms = document.querySelectorAll("product-form.product-form-buttons");
	const productForms = [...tabsForms, ...buttonForms];
	productForms.forEach((productForm) => {
		if (!productForm) return;
		const form = productForm.querySelector(".form");
		if (form.dataset.directCheckout == "false") return;

		let products = {};

		form.querySelector(".product-form__submit").addEventListener("click", (event) => {
			event.preventDefault();

			const productId = productForm.querySelector(".form").dataset.productvariantid;
			console.log('productId: ', productId)

			// console.log('Promos: ', promos);
			let isSubscription = false;
			// Get product and properties based on form data
			const inputFields = form.querySelectorAll('[name^="properties["]');
			const properties = {};

			const quantity = event.target.closest("product-form").querySelector(".quantity__input")?.value || 1;

			inputFields.forEach((field) => {
				const key = field.name.match(/\[(.*?)\]/)[1];
				const value = field.value;
				properties[key] = value;
			});

			const $select = form.querySelector(".selling-plan-select");

			if (productForm.classList.contains("subscription-checked")) {
				const selectedIndex = $select.selectedIndex;
				products = {
					items: [
						{
							id: productId,
							selling_plan: $select.value,
							quantity: 1,
							frequency: $select.options[selectedIndex].text
						},
					],
				};
				isSubscription = true;
			} else {
				products = {
					items: [
						{
							id: productId,
							quantity,
						},
					],
				};

				if (window.isTryNowActive) {
					products.items[0].selling_plan = $select.value;
				}
			}
			// Append the properties to the product
			products.items[0].properties = properties;

			promos.forEach((promo) => {
				if (promo.promo == "bogo_promo") {
					promo.bogoRequired.forEach((requiredId) => {
						if (requiredId == productId && promo.threshold <= 1) {
							if (!promo.subscriptionOnly || (promo.subscriptionOnly && isSubscription)) {
								if (!window.disableAddGift) {
									promo.giftsVariantId.forEach((giftId) => {
										products.items.push({
											id: giftId,
											quantity: 1,
											properties: promo.properties,
										});
									});
								}
							}
						}
					});
				}
			});

			addProductsAndCheckout(products);
		});
	});
}

function getQueryParam(param) {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(param);
}

// Add products to cart & redirect to checkout
function addProductsAndCheckout(products = {}) {
	const subscriptionProduct = products.items.find((item) => item.frequency);
	const experiment = getQueryParam('experiment');
	const crossSellId = getQueryParam('cross_id');
	console.log('products: ', products);
	fetch(window.Shopify.routes.root + "cart/add.js", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			...products,
			sections: 'checkout-savings'
		}),
	})
		.then((response) => response.json())
		.then((response) => {
      if (
				response.sections &&
				response.sections['checkout-savings'] &&
				window.handleSectionPayload
			) {
        return window.handleSectionPayload(response.sections['checkout-savings'])
      }
      return Promise.resolve()
    })
		.then(() => {
			const crossSellId = document.querySelector('[data-upsell-modal]')?.dataset.upsellModal;
			if (crossSellId) {
				const event = new CustomEvent("buyboxProductAdded", {
					detail: {
						// frequency: subscriptionProduct?.frequency,
						frequency: null,
						crossSellId,
					},
				});
				document.dispatchEvent(event);
			} else {
				if (window.isTryNowActive) {
					setTimeout(() => {
						window.location.href = "/checkout";
					}, 500);
				} else {
					window.location.href = "/checkout";
				}
			}
		})
		.catch((error) => {
			console.error("Error:", error);
		});
}
